import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { BackButton, NextButton } from "@dhxete/button";
import RequiredDisclaimer from "../RequiredDisclaimer/RequiredDisclaimer";
import Question from "../Question/Question";
import Context from "../Context";

const Footer = ({
  state,
  dispatch,
  chatDetails,
  className,
  requiredDisclaimer = false,
  hideBackButton = false,
  hideNextButton = false,
  handleBack,
  nextButtonContent,
  enableNextButton = true,
  handleNext,
  hasQuestion = false,
  handleExpansion,
  // handle expansion for Footer  and Page
  handleAgentLoad,
  handleAgentAvailable,
  chatSubject,
  chatDescription,
  // chat
  handleNextButtonId,
  handleBackButtonId,
  handleQuestionButtonId,
  handleCaseButtonId,
  handleAgentButtonId,
  requiredDisclaimerId,
  handleAgentAnalytics,
  handleCaseAnalytics,
  handleSupportAnalytics,
  hasExtension
}) => {
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      state,
      dispatch,
      chatDetails,
      chatSubject,
      chatDescription,
      handleAgentLoad,
      handleAgentAvailable,
      handleAgentAnalytics,
      handleCaseAnalytics,
      handleSupportAnalytics,
      handleExpansion,
      hasExtension
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, requiredDisclaimer && /*#__PURE__*/React.createElement(RequiredDisclaimer, {
    id: requiredDisclaimerId
  }), /*#__PURE__*/React.createElement(BackButton, {
    hideBackButton: hideBackButton,
    handleClick: handleBack,
    id: handleBackButtonId
  }), /*#__PURE__*/React.createElement(NextButton, {
    hideNextButton: hideNextButton,
    handleClick: handleNext,
    enable: enableNextButton,
    langStrings: state.langStrings,
    id: handleNextButtonId
  }, nextButtonContent), hasQuestion && /*#__PURE__*/React.createElement(Question, {
    questionId: handleQuestionButtonId,
    caseButtonId: handleCaseButtonId // this is for styling and load testing, not for Salesforce.
    ,
    agentButtonId: handleAgentButtonId
  })));
};

Footer.propTypes = {
  state: PropTypes.object,
  dispatch: PropTypes.func,
  className: PropTypes.string,
  requiredDisclaimer: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  handleBack: PropTypes.func,
  nextButtonContent: PropTypes.string,
  enableNextButton: PropTypes.bool,
  handleNext: PropTypes.func,
  hasQuestion: PropTypes.bool,
  chatDetails: PropTypes.object.isRequired,
  chatSubject: PropTypes.string.isRequired,
  chatDescription: PropTypes.string.isRequired,
  handleAgentLoad: PropTypes.func,
  handleAgentAvailable: PropTypes.func,
  handleNextButtonId: PropTypes.string,
  handleBackButtonId: PropTypes.string,
  requiredDisclaimerId: PropTypes.string,
  handleQuestionButtonId: PropTypes.string,
  handleCaseButtonId: PropTypes.string,
  handleAgentButtonId: PropTypes.string,
  handleAgentAnalytics: PropTypes.func,
  handleCaseAnalytics: PropTypes.func,
  handleExpansion: PropTypes.func,
  hasExtension: PropTypes.bool
}; // changes

export default styled(Footer)`
  margin-top: auto;
  ${props => props.hasExtension && css`
    position: relative;
  `}

  ${({
  hasQuestion
}) => !hasQuestion && `
    margin-bottom: 50px;
  `}
`;